<template>
  <div class="container">
    <div
      class="col-lg-4 col-md-6 ml-auto mr-auto"
      v-if="!showSelecionarEmpresa"
    >
      <div v-if="!modoManutencao">
        <form @submit.prevent="loginFuncionarioF">
          <card class="card-login card-white text-left">
            <template slot="header">
              <!-- <img src="img/repL1.png" class="card-img" width="50"/> -->
              <!-- <h1 class="card-title">Registre seu ponto</h1> -->
            </template>
            <div class="d-flex justify-content-evenly pt-1 pb-3">
              <img
                src="img/Logo_L2.png"
                class="card-img"
                style="width: 200px;"
              />
              <!-- <h4 class="card-title">Registre seu ponto</h4> -->
            </div>

            <div>
              <base-input
                v-show="tipoLoginFunc === 'false'"
                type="tel"
                v-mask="'##.###.###/####-##'"
                :masked="false"
                v-model="loginFuncionario.cnpj"
                placeholder="CNPJ"
                addon-left-icon="tim-icons icon-bank"
              >
              </base-input>

              <base-input
                v-if="tipoLoginFunc === 'true'"
                id="cpf_login"
                v-model="loginFuncionario.cpf"
                type="tel"
                autofocus
                v-mask="'###.###.###-##'"
                :masked="true"
                placeholder="CPF"
                addon-left-icon="tim-icons icon-badge"
              >
              </base-input>
            </div>

            <div class="col-sm-10 checkbox-radios d-flex flex-row p-0">
              <base-radio name="true" v-model="tipoLoginFunc" class="mr-3"
                >Colaborador</base-radio
              >
              <base-radio name="false" v-model="tipoLoginFunc"
                >Empresa</base-radio
              >
            </div>

            <div slot="footer">
              <base-button
                native-type="submit"
                type="success"
                class="mb-3"
                size="lg"
                :disabled="disabledBtnEntrarF()"
                block
              >
                Entrar
              </base-button>
              <div class="d-flex justify-content-evenly pt-2">
                <strong>Modo Funcionário</strong>
              </div>
              <div class="d-flex justify-content-evenly">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.REP671CPF"
                >
                  <img
                    alt="Link app"
                    src="img/baixe.png"
                    style="width: 120px;"
                  />
                </a>
              </div>
              <div class="d-flex justify-content-evenly pt-2">
                <strong>Modo Kiosque</strong>
              </div>
              <div class="d-flex justify-content-evenly pb-3">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.REP671KIOSQUE"
                >
                  <img
                    alt="Link app 2"
                    src="img/baixe.png"
                    style="width: 120px;"
                  />
                </a>
              </div>
            </div>
          </card>
        </form>
      </div>
      <div
        v-else
        class="card card-login card-white text-center p-4"
        style="border-radius: 12px;"
      >
        <div class="d-flex justify-content-center pb-3">
          <img src="img/Logo_L2.png" class="card-img" style="width: 180px;" />
        </div>

        <h3 class="mb-1">
          COMUNICADO
        </h3>

        <p style="font-size: 16px; line-height: 1.6;">
          Baixar nosso app abaixo para ter acesso a seus pontos e assinaturas.
        </p>

        <div class="pt-2">
          <strong>Android:</strong>
        </div>

        <div class="d-flex justify-content-center pt-2">
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.REP671CPF"
          >
            <img
              alt="Link app android"
              src="img/baixe.png"
              style="width: 140px;"
            />
          </a>
        </div>

        <div class="pt-2">
          <strong>iOS:</strong>
        </div>

        <div class="d-flex justify-content-center pt-2">
          <a
            target="_blank"
            href="https://apps.apple.com/br/app/rep671-registro-de-ponto/id6453637363"
          >
            <img
              alt="Link app ios"
              src="img/imageios.png"
              style="width: 142px;"
            />
          </a>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col d-flex justify-content-evenly">
          <h3 class="fw-lighter">
            Clique no <b>POSTO DE TRABALHO</b> que deseja Registrar seu Ponto
          </h3>
        </div>
      </div>

      <div class="row">
        <div
          class="col d-flex justify-content-evenly"
          v-for="item in listEmpresas"
          :key="item.DS_LOCAL"
          @click="clickCard(item)"
        >
          <card class="text-center car pt-4 pb-0">
            <h2>
              {{ item.DS_LOCAL ? item.DS_LOCAL : item.NM_FANTASIA_EMPREGADOR }}
            </h2>
          </card>
        </div>
      </div>
    </div>
    <Carregando v-if="isLoading" />
  </div>
</template>
<script>
import { Card, BaseInput } from "@/components/index";
import Carregando from "../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";
import jwt from "jsonwebtoken";
import globalVariable from "../../globalVariable";
import ContentFooter from "../../../src/pages/Layout/ContentFooter.vue";

export default {
  components: {
    Card,
    BaseInput,
    Carregando,
    ContentFooter,
  },
  data() {
    return {
      modoManutencao: true,
      isLoading: false,
      showSelecionarEmpresa: false,
      empresaSelecionada: {},
      listEmpresas: [],
      tipoLogin: "false", //0 - cpf / 1 - cnpj
      tipoLoginFunc: "true",
      coordenadas: [],
      loginFuncionario: {
        cnpj: "",
        senha: "",
        cpf: "",
      },
      loginEmpresa: {
        cnpj: "",
        cpf: "",
        senha: "",
      },
      model: {
        cnpj: "",
        cpf: "",
        password: "",
        subscribe: true,
      },
    };
  },
  mounted() {
    //this.$nextTick(() => this.$refs.cpf22.focus());
    setTimeout(() => {
      document.getElementById("cpf_login").focus();
    }, 1000);

    if (document.body.classList != "sidebar-mini") {
      document.body.classList.toggle("sidebar-mini");
    }
    /* this.$root.$on('voltarMenuLogin', () => {
      this.itemMenu = 1
    }); */

    this.$getLocation().then((coordinates) => {
      this.coordenadas = coordinates;
      console.log(coordinates);
    });
  },
  methods: {
    disabledBtnEntrarF() {
      if (this.tipoLoginFunc === "true") {
        if (this.loginFuncionario.cpf.length == 14) {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.loginFuncionario.cnpj.length == 18) {
          return false;
        } else {
          return true;
        }
      }
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    clickCard(params) {
      let w1 = jwt.sign(
        { foo: "bar", exp: Math.floor(Date.now() / 1000) + 30 * 60 },
        globalVariable.KEY_LEVEL_10,
      );
      this.$session.set("w_", w1);
      params.tipo = "F";
      this.$session.set("dados", JSON.stringify(params));
      this.$session.set(
        "facial",
        JSON.stringify({
          cpf: params.CPF_EMPREGADO,
          idEmpregado: params.ID_EMPREGADO,
          idEmpregador: params.ID_EMPREGADOR,
          FUSO: params.FUSO,
        }),
      );

      this.empresaSelecionada = params;
      this.$router.push("/registrarPonto/colaborador");
    },

    disabledBtnEntrarE() {
      if (this.loginEmpresa.cnpj.length == 18) {
        return false;
      } else {
        return true;
      }
    },

    async loginFuncionarioF() {
      if (this.tipoLoginFunc === "false") {
        this.loginEmpresaF2();
        return;
      }
      // this.loginFuncionario.cnpj = this.loginFuncionario.cnpj.replace(/[. - / - -]/g, '')
      this.loginFuncionario.cpf = this.loginFuncionario.cpf.replace(
        /[. - -]/g,
        "",
      );

      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        cpf_empregado: this.loginFuncionario.cpf,
      };
      this.axios
        .post("/api/login/loginEmpregadoApenasCpf", bodyFormData)
        .then((response) => {
          th.isLoading = false;

          let w1 = jwt.sign(
            { foo: "bar", exp: Math.floor(Date.now() / 1000) + 30 * 60 },
            globalVariable.KEY_LEVEL_10,
          );

          th.$session.set("w_", w1);
          let dados = response.data.data.dados[0];
          dados.tipo = "F";
          th.$session.set("dados", JSON.stringify(dados));

          th.$session.set(
            "facial",
            JSON.stringify({
              cpf: dados.CPF_EMPREGADO,
              idEmpregado: dados.ID_EMPREGADO,
              idEmpregador: dados.ID_EMPREGADOR,
              FUSO: dados.FUSO,
              matricula: dados.matricula,
              matricula2: dados.matricula2,
            }),
          );

          if (response.data.data.dados.length > 1) {
            th.showSelecionarEmpresa = true;
            th.listEmpresas = response.data.data.dados;
          } else {
            if (response.data.data.dados.length == 1) {
              th.$router.push("/registrarPonto/colaborador");
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                "Usuario não encontrado!",
                "error",
              );
            }
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Usuario não encontrado!", "error");
        });
    },

    loginEmpresaF2() {
      let th = this;
      let cpf_cnpj = "";
      this.isLoading = true;
      cpf_cnpj = this.loginFuncionario.cnpj.replace(/[. - / - -]/g, "");

      let bodyFormData = {
        cpf_cnpj_login: cpf_cnpj,
      };

      this.axios
        .post("/api/login/loginEmpregadorCnpj", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          let dados = response.data.data.dados[0];
          let w1 = jwt.sign(
            { foo: "bar", exp: Math.floor(Date.now() / 1000) + 30 * 60 },
            globalVariable.KEY_LEVEL_7,
          );
          th.$session.set("w_", w1);
          dados.tipo = "E";
          th.$session.set("dados", JSON.stringify(dados));
          th.recuperarDados(
            dados.db_name,
            "/registrarPonto/empresa",
            dados.cnpj_login,
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Usuario e Senha Incorreto!",
            "error",
          );
          // warning, error, success, info, and question
        });
    },

    recuperarDados(db, route, cnpj) {
      const carregarDados = () => {
        return JSON.parse(this.$session.get("dados"));
      };

      const atualizarDados = (idEmpregador) => {
        let dados = carregarDados();
        dados.ID_EMPREGADOR = idEmpregador;

        this.$session.set("dados", JSON.stringify(dados));

        return true;
      };

      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: db,
        cpf_cnpj: cnpj,
      };

      this.axios
        .post("/api/empregador/listarEmpregadorPorCpfCpnj", bodyFormData)
        .then((response) => {
          let dados = response.data.data.dados[0];
          th.isLoading = false;
          atualizarDados(dados.id);
          // th.$cookies.set("idEmpregador", dados.id);
          th.$router.push(route);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao recuperar dados!",
            "error",
          );
        });
    },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.car {
  cursor: pointer;
  width: 340px;
  transition: transform 0.5s;
}

.car:hover {
  background: #f3f3f3;
  transform: scale(1.1);
  -webkit-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  transition: transform 0.2s;
}

.car:active {
  transform: scale(1);
  -webkit-box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
}

@media (max-width: 768px) {
  /* força todos os inputs do sistema */
  input,
  textarea,
  select {
    font-size: 16px !important;
  }

  /* pega especificamente o teu base-input */
  .base-input input,
  .input-group input,
  .form-control {
    font-size: 16px !important;
  }
}
</style>
